var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('the-layout-portal', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title pt-4",
    class: _vm.color
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("thg.ThgTable.title")))]), _c('v-text-field', {
    staticClass: "mx-2",
    attrs: {
      "dense": "",
      "append-icon": "mdi-magnify",
      "label": _vm.$t('thg.ThgTable.search'),
      "single-line": "",
      "hide-details": "",
      "outlined": ""
    },
    model: {
      value: _vm.search,
      callback: function callback($$v) {
        _vm.search = $$v;
      },
      expression: "search"
    }
  }), _c('v-spacer'), _c('thg-batch-update-items-by-vin-dialog', {
    staticClass: "ml-1 mr-1",
    attrs: {
      "thgs": _vm.thgs
    },
    on: {
      "parsed": _vm.updateSelected
    }
  }), _c('thg-batch-update-dialog', {
    staticClass: "ml-1 mr-1",
    attrs: {
      "thgs": _vm.selected
    },
    on: {
      "failed": _vm.selectFailed
    }
  }), _c('thg-multi-quick-checkout-dialog', {
    staticClass: "ml-1 mr-1",
    attrs: {
      "thgs": _vm.selected
    }
  }), _c('thg-billing-recreation-individual-dialog', {
    staticClass: "ml-1 mr-1",
    attrs: {
      "thgs": _vm.selected
    }
  })], 1), _c('v-divider'), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.thgs,
      "search": _vm.search,
      "loading": _vm.isLoadingAll,
      "dense": "",
      "item-key": "id",
      "show-select": ""
    },
    model: {
      value: _vm.selected,
      callback: function callback($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }